// Import and register all your controllers from the importmap under controllers/*

import { application } from "./application";

import DropdownInputController from "./dropdown_input_controller";
import PasswordInputController from "./password_input_controller";
import NotificationController from "./notification_controller";
import SwiperController from "./swiper_controller";
import BannerController from "./banner_controller";
import SwiperPartnerController from "./swiper_partner_controller";
import NavController from "./nav_controller";
import SkydioAccordionController from "./skydio_accordion_controller";
import ToastController from "./toast_controller";
import NumberAnimationController from "./number_animation_controller";
import DecimalAnimationController from "./decimal_animation_controller";
import NewsletterBoxController from "./newsletter_box_controller";
import LanguageController from "./language_controller";

application.register("dropdown-input", DropdownInputController);
application.register("password-input", PasswordInputController);
application.register("notification", NotificationController);
application.register("swiper", SwiperController);
application.register("banner", BannerController);
application.register("swiper-partner", SwiperPartnerController);
application.register("nav", NavController);
application.register("skydio-accordion", SkydioAccordionController);
application.register("toast", ToastController);
application.register("number-animation", NumberAnimationController);
application.register("decimal-animation", DecimalAnimationController);
application.register("newsletter-box", NewsletterBoxController);
application.register("language", LanguageController);

// Lazy load controllers as they appear in the DOM (remember not to preload controllers in import map!)
// import { lazyLoadControllersFrom } from "@hotwired/stimulus-loading"
// lazyLoadControllersFrom("controllers", application)
